<!-- 商品设置 -->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <el-collapse   v-model="activeName" accordion>
      <el-collapse-item :name="1">
        <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template>
        <!--查询条件区域-->
        <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
          <div class="filter-container" style="margin-top: 10px;display:none;">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="店铺:">
                <el-input v-model="queryParam.shopFrontId" placeholder="店铺ID"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-container" style="margin-top: 10px">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="商品名称:">
                <el-input v-model="queryParam.goodsName" placeholder="商品名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div>
        </el-card>
      </el-collapse-item>

    </el-collapse>


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
              :data="tableData"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              v-loading="listLoading"
              ref="seleteTable"
              max-height="650"
              border>
        <el-table-column prop="goodsName" label="商品名称" ></el-table-column>
        <el-table-column prop="goodsId" label="商品编号" ></el-table-column>
        <el-table-column prop="goodsType" label="商品分类" ></el-table-column>
        <el-table-column prop="unit" label="商品单位" ></el-table-column>
        <el-table-column prop="brand" label="品牌" ></el-table-column>
        <el-table-column prop="price" label="价格" ></el-table-column>
        <el-table-column prop="cost" label="成本" ></el-table-column>
        <el-table-column prop="status" label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">启用</span>
            <span v-if="scope.row.status == 1">停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button> -->
            <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              :page-sizes="queryParam.pageSizes"
              :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--    添加-->
    <el-dialog
            title="新增"
            :visible.sync="visibleDlg"
            width="50%"
            center>
      <goods-detail
              :detail-param="createParam"
              :create-type=1
              @onBtnOK="onBtnOK"
              @onGoods="onGoods"
              @onBtnCancel="onBtnCancel()"
      >
      </goods-detail>
    </el-dialog>
    <el-dialog
            title="修改商品"
            :visible.sync="visibleDlgUpdate"
            width="50%"
            center>
      <div>
        <el-form  ref="registerRef"  label-width="150px">
          <el-form-item label="商品名称" prop="goodsName">
            <el-input  maxlength="20"  show-word-limit v-model="updateParam.goodsName" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="商品ID" prop="goodsId">
            <el-input  maxlength="20"  show-word-limit v-model="updateParam.goodsId" placeholder="" style="width: 300px;" ></el-input>
          </el-form-item>
          <el-form-item  label="商品分类:"  prop="goodsType">
            <el-input style="width: 300px" v-model="updateParam.goodsType" placeholder=""></el-input>
          </el-form-item>
          <el-form-item  label="商品单位:" prop="unit" >
            <el-input style="width: 300px" v-model="updateParam.unit" placeholder=""></el-input>
          </el-form-item>

          <el-form-item  label="品牌:" prop="brand" >
            <el-input style="width: 300px" v-model="updateParam.brand"></el-input>
          </el-form-item>
          <el-form-item  label="所在区域:" prop="region" >
            <el-input style="width: 300px" v-model="updateParam.region"></el-input>
          </el-form-item>
          <el-form-item  label="价格:" prop="price" >
            <el-input style="width: 300px" v-model="updateParam.price"></el-input>
          </el-form-item>
          <el-form-item  label="成本:" prop="cost" >
            <el-input style="width: 300px" v-model="updateParam.cost"></el-input>
          </el-form-item>
          <el-form-item  label="状态:" prop="status" >
            <el-select v-model="updateParam.status" placeholder="状态">
              <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="备注:" >
            <el-input
                    type="textarea"
                    placeholder=""
                    v-model="updateParam.remark"
                    maxlength="30"
                    show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgUpdate = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateOne">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {queryGoods, addGoods,updateGoods,delGoods} from "../../../api/Goods";
  import goodsDetail from "./components/goodsDetail";
  import messageUtils from "../../../utils/messageUtils";


  export default {
    components:{goodsDetail},
    data() {
      return {
        listLoading: true,
        //查询参数
        queryParam: {
          shopFrontId:globaldata.getAdminStore().storeFrontId,
          //分页查询
          pageNum :1 ,//当前第几页
          pageSize : 10,
        },
        totalPage :1, //总共页数
        pageSizes:[20,50,100],
        //查询区域默认展开
        activeName:1,
        createParam :{
        },
        //删除
        deleteParam :{
        },
        updateParam:{
          id:'',
          shopFrontId:'',
          goodsId:'',
          goodsName :''  ,
          goodsType : '' ,
          unit : '' ,
          brand : '' ,
          price : '',
          cost : '',
          status:'',
          remark:'',
        },
        //弹窗
        visibleDlg: false,
        visibleDlgUpdate :false,
        //表单结果
        tableData: [
        ],
        allWorker:[],
        options: [{
          value: '0',
          label: '启用'
        }, {
          value: '1',
          label: '停用'
        }],
      }


    },
    created(){
      this.fitchList()
    },
    mounted() {

    },
    methods: {

      //点击查询按钮
      onBtnSearch() {
        this.fitchList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      refreshData(list){
        this.tableData = list;
      },
      //添加一个
      handleCreateOne(){
        this.visibleDlg = true;
      },
      onBtnOK(){
        this.visibleDlg = false;
        this.fitchList();
      },
      //新增保存
      onGoods(data){
        data.shopFrontId =globaldata.getAdminStore().storeFrontId;
        addGoods(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
          this.fitchList();
        })
      },
      onBtnCancel(){
        this.visibleDlg = false;
      },
      //刪除
      handleDeleteOne(row){
        console.info('删除')
        this.$confirm('是否要删除商品名为：'+ row.goodsName +' 的商品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          let param = {
            id:row.id,
          }
          delGoods(param).then(response => {
            let data = response.data;
            if (data == true){
              messageUtils.successMsg(this,response.message);
              this.fitchList();
            }else {
              messageUtils.errorMsg(this,response.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      fitchList(){
        this.listLoading = true;
        queryGoods(this.queryParam).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.totalPage = data.total;

          this.refreshData(data.list);
        })
      },
      //打开修改弹出框
      handleUpdateOneDlg(row){
        this.visibleDlgUpdate =true;
        this.updateParam = {
          id:row.id,
          shopFrontId:row.shopFrontId,
          goodsId:row.goodsId,
          goodsName:row.goodsName,
          goodsType:row.goodsType,
          unit:row.unit,
          brand:row.brand,
          price:row.price,
          cost:row.cost,
          status:row.status,
          remark:row.remark,
        }
      },
      handleUpdateOne() {
        let param = {
          id : this.updateParam.id,
          shopFrontId:globaldata.getAdminStore().storeFrontId,
          goodsId:this.updateParam.goodsId,
          goodsName:this.updateParam.goodsName,
          goodsType:this.updateParam.goodsType,
          unit:this.updateParam.unit,
          brand:this.updateParam.brand,
          price:this.updateParam.price,
          cost:this.updateParam.cost,
          status:this.updateParam.status,
          remark:this.updateParam.remark,
        }
        updateGoods(param).then(response =>
        {
          let data = response.data;
          if (data == true){
            messageUtils.successMsg(this,response.message);
            this.fitchList();
            this.visibleDlgUpdate= false;
          }else {
            messageUtils.errorMsg(this,response.message);
          }
        })
      },
    }
  }



</script>






// WEBPACK FOOTER //
// src/views/my-store/goods/index.vue